(function() {
  let particles = [];
  const { round, ceil, abs, sign, PI, sin, cos } = Math,
        scene = document.querySelector('.scene'), 
        g_particles = scene.querySelector('.particles'), 
        
        vb = scene.getAttribute('viewBox').split(' '), 
        vb_w = ~~vb[2], vb_h = ~~vb[3], 
        vb_x = ~~vb[0], vb_y = ~~vb[1], 
          
        u = 3;

  // 
  // Helper functions
  // 
  const rand = (max, min) => {
    const b = (!max && max !== 0) ? 1 : max,
          a = min || 0;

    return a + (b - a)*Math.random();
  };

  // 
  // class Particle
  // 
  class Particle {
    static get radius() {
      return 11;
    };

    constructor(el) {
      const a = PI*rand(2),
            va = round(rand(4, 1)*u);

      this.v = { 'x': va*cos(a), 'y': va*sin(a) };
      this.el = el;
      this.p = {
        'x': round(rand(vb_w)), 
        'y': round(rand(vb_h))
      };

      this.setAttrs({'transform': `translate(${this.p.x} ${this.p.y})`});
    }
    
    dx(x) {
      return abs(this.p.x - x);
    };
    
    dy(y) {
      return abs(this.p.y - y);
    };
    
    hitsWallX() {
      return (this.dx(vb_x) <= 2 * Particle.radius) || (this.dx(vb_w + vb_x) <= 2 * Particle.radius);
    };
    
    hitsWallY() {
      return (this.dy(vb_y) <= 2 * Particle.radius) || (this.dy(vb_h + vb_y) <= 2 * Particle.radius);
    };

    setAttrs(attr_obj) {
      for(var prop in attr_obj) {
        this.el.setAttribute(prop, attr_obj[prop]);
      }
    };
  };

  // 
  // Initializaiton
  // 
  const init = () => {
    const particleNodes = g_particles.children;
    
    for (let particle of particleNodes) {
      particles.push(new Particle(particle));
    }

    g_particles.style.opacity = 1;
  };



  // 
  // Animation
  // 
  const move = () => {
    for (let particle of particles) {
      const dx = ceil(abs(particle.v.x)) * sign(particle.v.x) / 25;
      const dy = ceil(abs(particle.v.y)) * sign(particle.v.y) / 25;
      particle.p.x += dx;
      particle.p.y += dy;

      const { x, y } = particle.p;

      particle.setAttrs({
        'transform': `translate(${x} ${y})`
      });

      if(particle.hitsWallX()) {
        particle.v.x *= -1;
      }
      if(particle.hitsWallY()) {
        particle.v.y *= -1;
      }
    }

    requestAnimationFrame(move);
  };

  init();
  move();
})();